import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  province: 'México',
  pack: 'Pack Completo',
  time: 'hace 3 min'
}, {
  name: 'Carolina S.',
  province: 'Colombia',
  pack: 'Pack Completo',
  time: 'hace 5 min'
}, {
  name: 'Luciana R.',
  province: 'Perú',
  pack: 'Pack Básico',
  time: 'hace 8 min'
}, {
  name: 'Alejandra M.',
  province: 'Chile',
  pack: 'Pack Completo',
  time: 'hace 12 min'
}, {
  name: 'Gabriela P.',
  province: 'Ecuador',
  pack: 'Pack Completo',
  time: 'hace 15 min'
}, {
  name: 'Valeria D.',
  province: 'Guatemala',
  pack: 'Pack Básico',
  time: 'hace 18 min'
}, {
  name: 'Romina F.',
  province: 'Costa Rica',
  pack: 'Pack Completo',
  time: 'hace 22 min'
}, {
  name: 'Florencia G.',
  province: 'Uruguay',
  pack: 'Pack Completo',
  time: 'hace 25 min'
}, {
  name: 'Daniela V.',
  province: 'Paraguay',
  pack: 'Pack Básico',
  time: 'hace 30 min'
}, {
  name: 'Natalia B.',
  province: 'Bolivia',
  pack: 'Pack Completo',
  time: 'hace 35 min'
}, {
  name: 'Soledad K.',
  province: 'Honduras',
  pack: 'Pack Completo',
  time: 'hace 40 min'
}, {
  name: 'Andrea T.',
  province: 'Panamá',
  pack: 'Pack Básico',
  time: 'hace 45 min'
}, {
  name: 'Paula C.',
  province: 'Rep. Dominicana',
  pack: 'Pack Completo',
  time: 'hace 50 min'
}, {
  name: 'Cecilia H.',
  province: 'Venezuela',
  pack: 'Pack Completo',
  time: 'hace 55 min'
}, {
  name: 'Silvia N.',
  province: 'El Salvador',
  pack: 'Pack Básico',
  time: 'hace 1 hora'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showNext = () => {
    setVisible(true);
    timerRef.current = setTimeout(() => {
      setVisible(false);
      timerRef.current = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        showNext();
      }, 10000);
    }, 5000);
  };
  useEffect(() => {
    if (dismissed) return;
    timerRef.current = setTimeout(() => {
      showNext();
    }, 6000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [dismissed]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    if (timerRef.current) clearTimeout(timerRef.current);
  };
  const current = purchases[currentIndex];
  const isMasterPack = current.pack.includes('Completo');
  if (dismissed) return null;
  return <AnimatePresence data-id="element-224">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 80,
      scale: 0.9
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-3 left-3 right-3 md:bottom-4 md:left-6 md:right-auto md:max-w-sm z-50" data-id="element-225">
          <div className={`relative rounded-2xl p-4 shadow-2xl backdrop-blur-md ${isMasterPack ? 'bg-navy-900/95 border-2 border-gold-500/50 shadow-[0_0_25px_rgba(234,179,8,0.2)]' : 'bg-navy-900/95 border border-navy-700'}`} data-id="element-226">
            <button onClick={handleDismiss} className="absolute top-2 right-2 text-slate-500 hover:text-slate-300 p-1" data-id="element-227">
              <X className="w-3.5 h-3.5" data-id="element-228" />
            </button>

            <div className="flex items-start gap-3 pr-4" data-id="element-229">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isMasterPack ? 'bg-gold-500/20 text-gold-400' : 'bg-blue-500/20 text-blue-400'}`} data-id="element-230">
                <ShoppingBag className="w-5 h-5" data-id="element-231" />
              </div>

              <div className="min-w-0" data-id="element-232">
                <p className="text-white font-semibold text-sm leading-tight" data-id="element-233">
                  {current.name}
                  <span className="text-slate-400 font-normal" data-id="element-234">
                    {' '}
                    — {current.province}
                  </span>
                </p>
                <p className={`text-sm font-bold mt-0.5 ${isMasterPack ? 'text-gold-400' : 'text-blue-400'}`} data-id="element-235">
                  {isMasterPack ? '🏆 ' : '📘 '}
                  {current.pack}
                </p>
                <p className="text-[11px] text-slate-500 mt-1" data-id="element-236">
                  {current.time} · ✅ Compra verificada
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}